import { render, staticRenderFns } from "./applyCardList.vue?vue&type=template&id=572421f9&scoped=true"
import script from "./applyCardList.vue?vue&type=script&lang=js"
export * from "./applyCardList.vue?vue&type=script&lang=js"
import style0 from "./applyCardList.vue?vue&type=style&index=0&id=572421f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572421f9",
  null
  
)

export default component.exports